module.exports = __webpack_public_path__ + "img/ecpm-logo.d0061af8.png";